// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VsAutocadRouteImport } from './routes/vs-autocad'
import { Route as TutorialsRouteImport } from './routes/tutorials'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as OnlineRouteImport } from './routes/online'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as AiLivestreamRouteImport } from './routes/ai-livestream'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as pagesRouteRouteImport } from './routes/(pages)/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsVideosRouteImport } from './routes/settings/videos'
import { Route as SettingsTicketsRouteImport } from './routes/settings/tickets'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as SettingsPaymentsRouteImport } from './routes/settings/payments'
import { Route as SettingsCreditsRouteImport } from './routes/settings/credits'
import { Route as SettingsBillingRouteImport } from './routes/settings/billing'
import { Route as SettingsApikeysRouteImport } from './routes/settings/apikeys'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminTicketsRouteImport } from './routes/admin/tickets'
import { Route as AdminSubscriptionsRouteImport } from './routes/admin/subscriptions'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminPostsRouteImport } from './routes/admin/posts'
import { Route as AdminPermissionsRouteImport } from './routes/admin/permissions'
import { Route as AdminPaymentsRouteImport } from './routes/admin/payments'
import { Route as AdminInviteCodesRouteImport } from './routes/admin/invite-codes'
import { Route as AdminIndexnowRouteImport } from './routes/admin/indexnow'
import { Route as AdminFooterBadgesRouteImport } from './routes/admin/footer-badges'
import { Route as AdminCreditsRouteImport } from './routes/admin/credits'
import { Route as AdminCategoriesRouteImport } from './routes/admin/categories'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as pagesTermsOfServiceRouteImport } from './routes/(pages)/terms-of-service'
import { Route as pagesPrivacyPolicyRouteImport } from './routes/(pages)/privacy-policy'
import { Route as pagesContactRouteImport } from './routes/(pages)/contact'
import { Route as pagesAcceptableUsePolicyRouteImport } from './routes/(pages)/acceptable-use-policy'
import { Route as pagesAboutRouteImport } from './routes/(pages)/about'
import { Route as authVerifyEmailRouteImport } from './routes/(auth)/verify-email'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authRedeemInviteRouteImport } from './routes/(auth)/redeem-invite'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authAuthCallbackRouteImport } from './routes/(auth)/auth-callback'

const VsAutocadRoute = VsAutocadRouteImport.update({
            id: '/vs-autocad',path: '/vs-autocad',getParentRoute: () => rootRouteImport
          })
const TutorialsRoute = TutorialsRouteImport.update({
            id: '/tutorials',path: '/tutorials',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const OnlineRoute = OnlineRouteImport.update({
            id: '/online',path: '/online',getParentRoute: () => rootRouteImport
          })
const DownloadRoute = DownloadRouteImport.update({
            id: '/download',path: '/download',getParentRoute: () => rootRouteImport
          })
const AiLivestreamRoute = AiLivestreamRouteImport.update({
            id: '/ai-livestream',path: '/ai-livestream',getParentRoute: () => rootRouteImport
          })
const SettingsRouteRoute = SettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const pagesRouteRoute = pagesRouteRouteImport.update({
            id: '/(pages)',getParentRoute: () => rootRouteImport
          })
const authRouteRoute = authRouteRouteImport.update({
            id: '/(auth)',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const SettingsIndexRoute = SettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SettingsRouteRoute
          })
const SettingsVideosRoute = SettingsVideosRouteImport.update({
            id: '/videos',path: '/videos',getParentRoute: () => SettingsRouteRoute
          })
const SettingsTicketsRoute = SettingsTicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => SettingsRouteRoute
          })
const SettingsProfileRoute = SettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => SettingsRouteRoute
          })
const SettingsPaymentsRoute = SettingsPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => SettingsRouteRoute
          })
const SettingsCreditsRoute = SettingsCreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => SettingsRouteRoute
          })
const SettingsBillingRoute = SettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => SettingsRouteRoute
          })
const SettingsApikeysRoute = SettingsApikeysRouteImport.update({
            id: '/apikeys',path: '/apikeys',getParentRoute: () => SettingsRouteRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRouteRoute
          })
const AdminTicketsRoute = AdminTicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => AdminRouteRoute
          })
const AdminSubscriptionsRoute = AdminSubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AdminRouteRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRouteRoute
          })
const AdminRolesRoute = AdminRolesRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => AdminRouteRoute
          })
const AdminPostsRoute = AdminPostsRouteImport.update({
            id: '/posts',path: '/posts',getParentRoute: () => AdminRouteRoute
          })
const AdminPermissionsRoute = AdminPermissionsRouteImport.update({
            id: '/permissions',path: '/permissions',getParentRoute: () => AdminRouteRoute
          })
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AdminRouteRoute
          })
const AdminInviteCodesRoute = AdminInviteCodesRouteImport.update({
            id: '/invite-codes',path: '/invite-codes',getParentRoute: () => AdminRouteRoute
          })
const AdminIndexnowRoute = AdminIndexnowRouteImport.update({
            id: '/indexnow',path: '/indexnow',getParentRoute: () => AdminRouteRoute
          })
const AdminFooterBadgesRoute = AdminFooterBadgesRouteImport.update({
            id: '/footer-badges',path: '/footer-badges',getParentRoute: () => AdminRouteRoute
          })
const AdminCreditsRoute = AdminCreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => AdminRouteRoute
          })
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AdminRouteRoute
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AdminRouteRoute
          })
const pagesTermsOfServiceRoute = pagesTermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => pagesRouteRoute
          })
const pagesPrivacyPolicyRoute = pagesPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => pagesRouteRoute
          })
const pagesContactRoute = pagesContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => pagesRouteRoute
          })
const pagesAcceptableUsePolicyRoute = pagesAcceptableUsePolicyRouteImport.update({
            id: '/acceptable-use-policy',path: '/acceptable-use-policy',getParentRoute: () => pagesRouteRoute
          })
const pagesAboutRoute = pagesAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => pagesRouteRoute
          })
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => authRouteRoute
          })
const authSignUpRoute = authSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => authRouteRoute
          })
const authSignInRoute = authSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => authRouteRoute
          })
const authResetPasswordRoute = authResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => authRouteRoute
          })
const authRedeemInviteRoute = authRedeemInviteRouteImport.update({
            id: '/redeem-invite',path: '/redeem-invite',getParentRoute: () => authRouteRoute
          })
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => authRouteRoute
          })
const authAuthCallbackRoute = authAuthCallbackRouteImport.update({
            id: '/auth-callback',path: '/auth-callback',getParentRoute: () => authRouteRoute
          })





const authRouteRouteChildren = {
  authAuthCallbackRoute: authAuthCallbackRoute,authForgotPasswordRoute: authForgotPasswordRoute,authRedeemInviteRoute: authRedeemInviteRoute,authResetPasswordRoute: authResetPasswordRoute,authSignInRoute: authSignInRoute,authSignUpRoute: authSignUpRoute,authVerifyEmailRoute: authVerifyEmailRoute
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(authRouteRouteChildren)




const pagesRouteRouteChildren = {
  pagesAboutRoute: pagesAboutRoute,pagesAcceptableUsePolicyRoute: pagesAcceptableUsePolicyRoute,pagesContactRoute: pagesContactRoute,pagesPrivacyPolicyRoute: pagesPrivacyPolicyRoute,pagesTermsOfServiceRoute: pagesTermsOfServiceRoute
}

const pagesRouteRouteWithChildren = pagesRouteRoute._addFileChildren(pagesRouteRouteChildren)




const AdminRouteRouteChildren = {
  AdminAnalyticsRoute: AdminAnalyticsRoute,AdminCategoriesRoute: AdminCategoriesRoute,AdminCreditsRoute: AdminCreditsRoute,AdminFooterBadgesRoute: AdminFooterBadgesRoute,AdminIndexnowRoute: AdminIndexnowRoute,AdminInviteCodesRoute: AdminInviteCodesRoute,AdminPaymentsRoute: AdminPaymentsRoute,AdminPermissionsRoute: AdminPermissionsRoute,AdminPostsRoute: AdminPostsRoute,AdminRolesRoute: AdminRolesRoute,AdminSettingsRoute: AdminSettingsRoute,AdminSubscriptionsRoute: AdminSubscriptionsRoute,AdminTicketsRoute: AdminTicketsRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)




const SettingsRouteRouteChildren = {
  SettingsApikeysRoute: SettingsApikeysRoute,SettingsBillingRoute: SettingsBillingRoute,SettingsCreditsRoute: SettingsCreditsRoute,SettingsPaymentsRoute: SettingsPaymentsRoute,SettingsProfileRoute: SettingsProfileRoute,SettingsTicketsRoute: SettingsTicketsRoute,SettingsVideosRoute: SettingsVideosRoute,SettingsIndexRoute: SettingsIndexRoute
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(SettingsRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,authRouteRoute: authRouteRouteWithChildren,pagesRouteRoute: pagesRouteRouteWithChildren,AdminRouteRoute: AdminRouteRouteWithChildren,SettingsRouteRoute: SettingsRouteRouteWithChildren,AiLivestreamRoute: AiLivestreamRoute,DownloadRoute: DownloadRoute,OnlineRoute: OnlineRoute,PricingRoute: PricingRoute,TutorialsRoute: TutorialsRoute,VsAutocadRoute: VsAutocadRoute,BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)